import styled from "styled-components";

import { TextField as MuiTextField } from "@mui/material";

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 640px;

  @media (max-width: 768px) {
    width: calc(100% - 40px);
    margin: 0px 20px;
  }
`;

export const Container = styled.div`
  position: relative;
  // display: flex;
  // background-color: red;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const FormContainer = styled.div`
  flex-direction: row; /* 하위 요소들을 가로 방향으로 배치 */
  justify-content: center; /* 세로축 중앙 정렬 */
  align-items: center; /* 가로축 중앙 정렬 */
  display: contents;
`;

export const Header = styled.div`
  position: fixed;
  display: flex;
  height: 50px;
  width: 100%;
  margin-bottom: 16px;
  background-color: ${({ theme }) => theme.colors.WHITE};
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.GREY_HEAVY}`};
  flex-direction: row; /* 하위 요소들을 가로 방향으로 배치 */
  justify-content: center; /* 세로축 중앙 정렬 */
  align-items: center; /* 가로축 중앙 정렬 */
  z-index: 100;

  @media (max-width: 768px) {
    // padding: 10px;
    // width: calc(100% - 20px);
  }
`;

export const Edit = styled.div<{ color: string }>`
  background-color: ${({ color }) => color};
  color: white;
  width: 25px;
  height: 16px;
  padding: 8px;
  margin-left: 10px;
  font-size: 14px;
  border-radius: 8%;
`;

export const CompleteTitle = styled.div`
  border-top: 1px dashed blue;
  margin-top: 40px;
  padding: 80px 0px 20px 0px;
  font-weight: bold;
  font-size: 24px;
  text-align: center;

  @media (max-width: 768px) {
    width: calc(100% - 40px);
    padding: 20px;
  }
`;

export const Complete = styled.div`
  font-weight: bold;
  font-size: 24px;
  margin: 24px 0px 0px 0px;
  width: 640px;

  @media (max-width: 768px) {
    width: calc(100% - 40px);
    padding: 20px;
  }
`;

export const PreviewSubmitSection = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 200px;
`;

export const SubmitButton = styled.button`
  padding: 16px 40px 14px 40px;
  font-size: 16px;
  background-color: ${({ theme }) => theme.colors.BLUE_HEAVY};
  color: ${({ theme }) => theme.colors.WHITE};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin: 5px 10px;
`;

export const PartnerName = styled.div`
  font-size: 12px;
  margin-top: 60px;
  margin-bottom: 24px;
  padding-left: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.GREY_EXTRA_HEAVY};
`;

export const UrlPath = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.GREY_EXTRA_HEAVY};
  @media (max-width: 768px) {
    padding: 0px 20px;
  }
`;

export const PartnerNameInput = styled(MuiTextField)<{ alert: boolean }>`
  div {
    font-size: 14px;
    margin: 0px 10px;
    border-radius: 6px;
    text-align: center;
    height: 10px;
    background-color: #f7f9fd;
    padding: 15px 8px;
    width: 140px;

    border: ${({ alert }) => (alert ? `1px solid red` : `none`)};

    input {
      text-align: center;
    }

    ::before {
      border-bottom: ${({ theme }) => `0px solid ${theme.colors.GREY_HEAVY}`} !important;
    }

    ::after {
      border-bottom: ${({ theme }) => `2px solid ${theme.colors.BLUE_HEAVY}`};
    }
  }
`;

export const UrlInput = styled(MuiTextField)<{ alert: boolean }>`
  div {
    font-size: 14px;
    height: 10px;
    background-color: #e6e8eb;
    padding: 10px 3px;
    margin: 0px 2px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;

    border: ${({ alert }) => (alert ? `1px solid red` : `none`)};

    ::before {
      border-bottom: ${({ theme }) => `0px solid ${theme.colors.GREY_HEAVY}`} !important;
    }

    ::after {
      border-bottom: ${({ theme }) => `2px solid ${theme.colors.BLUE_HEAVY}`};
    }
  }
`;

export const Eye = styled.div`
  position: sticky;
  top: 100px;
  height: 50px;
  border-radius: 8px;
  box-shadow: none;
`;

// export const FormIcon = styled(SvgFrom)`
//   position: sticky;
//   top: 100px;
//   height: 50px;
//   border-radius: 8px;
//   box-shadow: none;
// `;

export const FabButton = styled.button`
  border: none;
  background-color: transparent;
  border-radius: 8px;
  box-shadow: none;
  position: absolute;
  right: 80px;
  top: 11px;

  &:hover::after {
    z-index: 100;
    content: "미리보기";
    position: absolute;
    bottom: -50%; /* 버튼의 위쪽에 툴팁을 표시 */
    right: 10%;
    margin-bottom: 8px; /* 버튼과 툴팁 간의 거리 */
    background-color: #333; /* 툴팁 배경색 */
    color: white; /* 툴팁 텍스트 색상 */
    padding: 5px 10px; /* 툴팁 내부 여백 */
    border-radius: 4px; /* 툴팁 모서리 둥글게 */
    white-space: nowrap; /* 텍스트가 한 줄에 표시되도록 */
    font-size: 12px; /* 툴팁 텍스트 크기 */
    opacity: 0; /* 초기에는 투명하게 설정 */
    visibility: hidden; /* 초기에는 보이지 않게 설정 */
    transition: opacity 0.2s, visibility 0.2s; /* 애니메이션 추가 */
  }

  &:hover::after {
    opacity: 1; /* 호버 시 툴팁 보이게 설정 */
    visibility: visible; /* 호버 시 툴팁 보이게 설정 */
  }

  @media (max-width: 768px) {
    display: none;
  }

  cursor: pointer;
`;

export const ApplyButton = styled.button`
  position: absolute;
  right: 36px;

  border: none;
  background-color: transparent;
  border-radius: 8px;
  box-shadow: none;
  margin-left: 4px;

  &:hover::after {
    z-index: 100;
    content: "신청서 페이지 바로가기";
    position: absolute;
    bottom: -50%; /* 버튼의 위쪽에 툴팁을 표시 */
    right: 10%;
    margin-bottom: 8px; /* 버튼과 툴팁 간의 거리 */
    background-color: #333; /* 툴팁 배경색 */
    color: white; /* 툴팁 텍스트 색상 */
    padding: 5px 10px; /* 툴팁 내부 여백 */
    border-radius: 4px; /* 툴팁 모서리 둥글게 */
    white-space: nowrap; /* 텍스트가 한 줄에 표시되도록 */
    font-size: 12px; /* 툴팁 텍스트 크기 */
    opacity: 0; /* 초기에는 투명하게 설정 */
    visibility: hidden; /* 초기에는 보이지 않게 설정 */
    transition: opacity 0.2s, visibility 0.2s; /* 애니메이션 추가 */
  }

  &:hover::after {
    opacity: 1; /* 호버 시 툴팁 보이게 설정 */
    visibility: visible; /* 호버 시 툴팁 보이게 설정 */
  }

  @media (max-width: 768px) {
    display: none;
  }

  cursor: pointer;
`;
